import { PkAvatar, PkIdentifier } from '@uefadigital/panenka-react';
import clsx from 'clsx';

import { getStatByName } from '../../utils/misc';
import type { TopScorerPlayer } from '../../utils/types';
import LinkOrAnchor from '../LinkOrAnchor';

import TeamBadge from '@shared/TeamBadge';
import { useTranslateFn } from '@shared/Translate';
import GtmHelper from '@tracking/gtm-helper';

import * as styles from './styles.module.scss';

export const SmallCard = ({
  idCard,
  player,
  divider,
  options,
}: {
  idCard: number;
  player: TopScorerPlayer;
  divider: boolean;
  options: any;
}) => {
  const t = useTranslateFn();

  const goalsValue = getStatByName(player, 'goals');
  const trackText = 'Tap player detail main';

  const onClickEvent = () => {
    GtmHelper.event(
      'Click',
      `${trackText} - ${player?.player?.internationalName}`,
      'topscorer',
      { section_reference: 'topscorer', interaction: `${trackText} - ${player?.player?.internationalName}` },
      'topscorer',
    );
  };
  return (
    <LinkOrAnchor
      enableUclPlayerPage={options.enableUclPlayerPage}
      playerId={player.player.id}
      onClickEvent={onClickEvent}
    >
      <div
        id={`id-card--${idCard}`}
        className={clsx({
          [styles.tsCardSquared]: true,
          'ts-card': true,
          'ts-card--squared': true,
          [styles.cardDivider]: divider,
        })}
      >
        <div className={clsx(styles.tsRank, 'ts-rank')}>
          <p className={clsx(styles.tsRankLabel, 'ts-rank__label')}>#{idCard}</p>
        </div>
        <div className={styles.tsPlayer}>
          <span className={styles.tsPlayerRank}>#{idCard}</span>
          <PkIdentifier className='pk-py--0' type='horizontal' order='normal'>
            <span slot='prefix'>
              <PkAvatar fallback-image='generic-head' type='image' size={48} src={player.player.imageUrl}>
                {player?.team && <TeamBadge slot='badge' team={player.team} size={14} />}
              </PkAvatar>
            </span>
            <span slot='primary' className={styles.tsPlayerPlayer}>
              <span>{player.player.shortName}</span>
            </span>
            <span slot='secondary'>
              <div className={styles.tsPlayerTeam}>
                <span className={styles.tsPlayerTeamName}>{player.team?.displayName}</span>
              </div>
            </span>
          </PkIdentifier>
          <div className={styles.tsStats}>
            <span className={styles.tsStatsGoals}>{goalsValue}</span>
            <span className={styles.tsStatsLabel}>{t(`${goalsValue > 1 ? 'stats_goals' : 'stats_goal'}`)}</span>
          </div>
        </div>
      </div>
    </LinkOrAnchor>
  );
};

export default SmallCard;
